import { Card } from "../../components/ui";

/** Constants and the stat tile shared by the recruitment screens, lifted out when the single page became four. */

export const CRIT_CLS: Record<string, string> = { Matched: "bg-green-50 text-status-green border-status-green/40", Unverified: "bg-amber-50 text-status-amber border-status-amber/40", Missing: "bg-red-50 text-status-red border-status-red/40" };
export const STATUS_CLS: Record<string, string> = { Screened: "bg-brand-grey-light text-brand-charcoal", Shortlisted: "bg-blue-50 text-brand-primary", "Interview scheduled": "bg-violet-50 text-violet-700", Rejected: "bg-red-50 text-status-red", Hired: "bg-green-50 text-status-green" };


export function Stat({ label, value }: { label: string; value: number | string }) {
  return <Card className="px-4 py-3"><div className="font-heading text-2xl font-semibold">{value}</div><div className="text-[11px] uppercase tracking-wide text-brand-grey">{label}</div></Card>;
}
